import { REFRESH_PATH } from "@/utils/persistentSession"

export const useApi = async (url, options = {}) => {
  const app = useNuxtApp()
  const session = useAuthSession()
  const config = useRuntimeConfig()
  const authFailure = useAuthFailure()
  const isAuthRequest = String(url).startsWith("/api/v1/auth/")
  try {
    if (String(url) === REFRESH_PATH) {
      await session.ensure({ force: true })
      return { data: ref(session.read()), pending: ref(false), error: ref(null), refresh: null }
    }
    if (!isAuthRequest) await session.ensure()
    let token = session.read()?.token
    const requestToken = ref(token)
    const headers = computed(() => {
      const result = new Headers(options.headers || {})
      if (!(options.body instanceof FormData) && !result.has("Content-Type")) result.set("Content-Type", "application/json")
      if (!isAuthRequest && requestToken.value) result.set("Authorization", `Bearer ${requestToken.value}`)
      return result
    })
    const state = await app.runWithContext(() => useFetch(url, {
      baseURL: config.public.apiBaseUrl,
      key: `${url}-${JSON.stringify(options.query ?? options.body ?? {})}`,
      ...options, headers, retry: 0, watch: false,
    }))
    const status = () => Number(state.error.value?.statusCode ?? state.error.value?.status ?? state.error.value?.response?.status)
    if (!isAuthRequest && token && status() === 401) {
      const renewed = await session.ensure({ force: true, rejectedToken: token })
      if (renewed) {
        token = renewed
        requestToken.value = renewed
        await state.refresh()
      }
      if (status() === 401 && session.read()?.token === token) authFailure.handleAuthFailure(401)
    }
    return state
  } catch (error) {
    if (!isAuthRequest && !session.read()?.refreshToken && Number(error?.statusCode ?? error?.status ?? error?.response?.status) === 401) authFailure.handleAuthFailure(401)
    return { data: ref(null), pending: ref(false), error: ref(error), refresh: null }
  }
}
